import { AccountDeactivationReasonEnum } from 'graph/globalTypes'
import PaymentIcon from 'Images/SVG/PaymentIcon.svg'
import AccountInfoIcon from 'Images/SVG/AccountInfoIcon.svg'
import NotificationsIcon from 'Images/SVG/NotificationsIcon.svg'
import DeactivateIcon from 'Images/SVG/DeactivateIcon.svg'

type SettingTab = {
  id: number
  label: string
  description: string
  href: string
  icon: string
}

export type ToastNotification = {
  label: string
  message: string
}

export const SettingsMenuEnum = {
  ACCOUNT_INFO: 1,
  PAYMENTS: 2,
  NOTIFICATIONS: 3,
  DEACTIVATE: 4,
}

export const getSettingsMenuTabs = (emailDigest: string): Array<SettingTab> => {
  return [
    {
      id: SettingsMenuEnum.ACCOUNT_INFO,
      label: 'Account info',
      description: 'Edit your personal info and login information',
      href: '/settings/account-info',
      icon: AccountInfoIcon,
    },
    {
      id: SettingsMenuEnum.PAYMENTS,
      label: 'Subscription & Payments',
      description: 'Manage your subscription and payment methods',
      href: '/settings/payments',
      icon: PaymentIcon,
    },
    {
      id: SettingsMenuEnum.NOTIFICATIONS,
      label: 'Notifications',
      description: 'Choose how to stay informed via email and text messages',
      href: `/settings/notifications`,
      icon: NotificationsIcon,
    },
    {
      id: SettingsMenuEnum.DEACTIVATE,
      label: 'Deactivate account',
      description: 'Close your account',
      href: '/settings/deactivate',
      icon: DeactivateIcon,
    },
  ]
}

export const ToastNotifications: Array<ToastNotification> = [
  {
    label: 'card-changed',
    message: 'Your card has been updated.',
  },
  {
    label: 'upgraded',
    message: 'Your plan has been upgraded.',
  },
  {
    label: 'plan-changed',
    message: 'Your plan has been changed.',
  },
  {
    label: 'sub-cancelled',
    message: 'Your subscription is cancelled.',
  },
  {
    label: 'discount-applied',
    message: 'A 50% discount has been applied to your next payment.',
  },
  {
    label: 'sub-reactivated',
    message: 'Your subscription is reactivated.',
  },
]

export const cancelReasons = (oppositeTypeKeyword: string) => {
  return [
    { id: 'found-match-here', reason: `I found a ${oppositeTypeKeyword} here` },
    { id: 'found-match-elsewhere', reason: `I found a ${oppositeTypeKeyword} elsewhere` },
    { id: 'no-longer-provider', reason: "I'm no longer providing the service" },
    { id: 'no-longer-seeker', reason: 'I no longer need the service' },
    { id: 'no-suitable-matches', reason: `I couldn't find any suitable ${oppositeTypeKeyword}` },
    { id: 'unsolicited-messages', reason: 'I received unsolicited messages or calls' },
    { id: 'other', reason: 'Another reason (Tell us more below)' },
  ]
}

export const getDeactivationReasons = (singular: string, plural: string, isSeeker: boolean) => [
  { id: AccountDeactivationReasonEnum.FOUND_MATCH_HERE, reason: `I found a ${singular} here` },
  {
    id: AccountDeactivationReasonEnum.FOUND_MATCH_ELSEWHERE,
    reason: `I found a ${singular} elsewhere`,
  },
  isSeeker
    ? {
        id: AccountDeactivationReasonEnum.NO_LONGER_SEEKER,
        reason: `I no longer need the service`,
      }
    : {
        id: AccountDeactivationReasonEnum.NO_LONGER_PROVIDER,
        reason: `I'm no longer providing the service`,
      },
  {
    id: AccountDeactivationReasonEnum.NO_SUITABLE_MATCHES,
    reason: `I couldn't find any suitable ${plural}`,
  },
  { id: AccountDeactivationReasonEnum.TOO_EXPENSIVE, reason: `The subscription is too expensive` },
  {
    id: AccountDeactivationReasonEnum.UNSOLICTED_MESSAGES,
    reason: `I received unsolicited messages or calls`,
  },
  { id: AccountDeactivationReasonEnum.OTHER, reason: `Another reason` },
]

export const DISCOUNT_ON_CANCELLATION_CODE = 'SVUUpWCa'
